export default "__VITE_ASSET__70d79ea4__"